import { Reveal, SectionHeading } from "@/components/site/Reveal";

export default function Services({ services }) {
  return (
    <section id="pageants" data-testid="services-section" className="mx-auto max-w-7xl px-6 py-28 lg:px-10 lg:py-36">
      <SectionHeading kicker="The Categories" title="Pageants for Every Age of Glory" testid="services-heading" />
      <div className="grid gap-8 md:grid-cols-2 lg:grid-cols-3">
        {services.map((s, i) => (
          <Reveal key={s.id || i} delay={(i % 3) * 0.1}>
            <article
              data-testid={`service-card-${i}`}
              className="group h-full border border-[#D4AF37]/20 bg-[#0C0C0C] transition-all duration-500 hover:-translate-y-2 hover:border-[#D4AF37]/60 hover:shadow-[0_20px_60px_-20px_rgba(212,175,55,0.25)]"
            >
              <div className="overflow-hidden">
                <img
                  src={s.image}
                  alt={s.title}
                  className="h-80 w-full bg-[#080808] object-contain transition-transform duration-700 group-hover:scale-105"
                />
              </div>
              <div className="p-8">
                <div className="flex items-center justify-between">
                  <span data-testid={`service-age-${i}`} className="text-[10px] uppercase tracking-[0.3em] text-[#D4AF37]">
                    {s.age_range}
                  </span>
                  <span className="font-display text-2xl font-light text-[#D4AF37]/30">
                    {String(i + 1).padStart(2, "0")}
                  </span>
                </div>
                <h3 data-testid={`service-title-${i}`} className="font-display mt-4 text-3xl font-medium text-white transition-colors duration-300 group-hover:text-[#D4AF37]">
                  {s.title}
                </h3>
                <p className="mt-4 text-sm font-light leading-relaxed text-neutral-400">{s.description}</p>
              </div>
            </article>
          </Reveal>
        ))}
      </div>
    </section>
  );
}
